import bathroomRemodelingIcons from "../svg/bathroom-remodeling";
import cabinetRefacingIcons from "../svg/cabinet-refacing";
import flooringIcons from "../svg/flooring";
import guttersIcons from "../svg/gutters";
import plumbingIcons from "../svg/plumbing";
import roofingIcons from "../svg/roofing";
import solarIcons from "../svg/solar";
import windowsIcons from "../svg/windows";

const icons = {
  ...cabinetRefacingIcons,
  ...bathroomRemodelingIcons,
  ...flooringIcons,
  ...guttersIcons,
  ...plumbingIcons,
  ...roofingIcons,
  ...solarIcons,
  ...windowsIcons,
};

const createProjectIcon = ({ icon, className }) => {
  if (!icons[icon]) {
    return null;
  }

  return () => (
    <svg className={className}>
      <use href={`${icons[icon]}#${icon}`} />
    </svg>
  );
};

export default createProjectIcon;
